import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { ModalityLookup } from '../../../../core/context/modalities-lookup';
import { ResourceService } from '../../../../core/services/resource-service';
import { getBooleanValue } from '../../../../core/utils/transformers';
import { ProceduresService } from '../../services/procedures-service';
@Component({
  selector: 'app-procedure-details',
  imports: [
    CommonModule,
    NzCardModule,
    NzTagModule,
    NzIconModule,
    NzButtonModule,
    NzGridModule,
    NzSpinComponent,
    RouterLink,
  ],
  templateUrl: './procedure-details.html',
  styleUrl: './procedure-details.scss',
})
export class ProcedureDetailsComponent {
  readonly route = inject(ActivatedRoute);
  readonly service = inject(ProceduresService);
  readonly resourceService = inject(ResourceService);
  readonly procedureId = Number(this.route.snapshot.paramMap.get('id'));
  readonly details = toSignal(this.service.get(this.procedureId), { initialValue: null });
  readonly modalities = ModalityLookup.modalities;
  readonly bodyAreas = toSignal(this.resourceService.getBodyAreas());
  readonly getBooleanValue = getBooleanValue;

  getModalityName(code: string): string | undefined {
    const modality = this.modalities.find((m) => m.code === code);
    return modality?.name;
  }
  getBodyAreaName(code: string): string | undefined {
    const bodyArea = this.bodyAreas()?.find((b) => b.code === code);
    return bodyArea?.name;
  }
}
